import { AutogenModelBrokerageMovements, AutogenRowBrokerageMovements } from "./autogen/AutogenModelBrokerageMovements";

export class ModelBrokerageMovements extends AutogenModelBrokerageMovements<RowBrokerageMovements> {
    constructor() {
        super(RowBrokerageMovements);
    }
}

export class RowBrokerageMovements extends AutogenRowBrokerageMovements {
}